import { connect } from "react-redux";

import {
  selectIsGreaterThanMedium,
  selectIsGreaterThanSmall
} from "~/store/ducks/application/browser";
import { selectIsMenuVisible } from "~/store/ducks/domain/ui/menu";
import { selectIsMaterialLayerEnabled } from "~/store/ducks/domain/ui/materialLayer";
import { selectIsSidebarRightVisible } from "~/store/ducks/domain/ui/sidebarRight";
import { selectIsSidebarLeftVisible } from "~/store/ducks/domain/ui/sidebarLeft";
import {
  selectLeftSidebarIsOpen,
  selectRightSidebarIsOpen
} from "~/store/ducks/user/uistate";
import { selectIntegrateMenu } from "~/store/ducks/domain/ui/header";

import AnnotationsMenu from "./AnnotationsMenu";

function mapStateToProps(state) {
  return {
    isGreaterThanMedium: selectIsGreaterThanMedium(state),
    isGreaterThanSmall: selectIsGreaterThanSmall(state),
    sidebarLeftOpen: selectLeftSidebarIsOpen(state),
    sidebarRightOpen: selectRightSidebarIsOpen(state),
    isMenuVisible: selectIsMenuVisible(state),
    isMaterialVisible: selectIsMaterialLayerEnabled(state),
    isSidebarLeftVisible: selectIsSidebarLeftVisible(state),
    isSidebarRightVisible: selectIsSidebarRightVisible(state),
    integrateMenu: selectIntegrateMenu(state)
  };
}

export default connect(mapStateToProps)(AnnotationsMenu);
